define([
    "jquery",
    "@modules/utils",
    "@modules/constants",
    "scanTranslations",
    "@modules/services/dataLayerService",
    "@modules/tools/urlParameters",
    "@modules/insensitiveProperty",
    "scrollMagic",
    "require",
    "slick",
    "velocity",
    "openclose",
    "accordion",
    "bootstrap",
    "bootstrap-select",
    "placeholder",
    "@modules/quickLinks",
    "@modules/news/newsTaxonomyFilters",
    "@modules/planMaterialsSearch",
    "dataTable",
    "jqueryOutsideEvents",
    "tabCollapse"
], function ($, utils, constants, scanTranslations, dataLayerService, urlParameters, getPropertyCaseInsensitive, ScrollMagic) {
    function initScreenBreakpointEvent() {
        var breakpoints = [constants.BREAKPOINT_MOBILE_SCREEN, constants.BREAKPOINT_TABLET_SCREEN];
        var lastBp = null;
        var $win = $(window);

        breakpoints = breakpoints.sort(function (a, b) {
            return a - b;
        });

        $win.on("resize orientationchange", checkScreenBreakpoint);

        function checkScreenBreakpoint() {
            var wWidth = window.innerWidth;
            var i = breakpoints.length,
                bp;
            while (i--) {
                bp = breakpoints[i] >= wWidth ? breakpoints[i] : bp;
            }
            if (lastBp !== bp) {
                $win.trigger("screenbreakpoint", [bp, lastBp]);
                lastBp = bp;
            }
        }
    }

    /*
     * Add Page Classes - add classes to the page container
     */
    function addPageClasses() {
        var $page = $("div.page");
        var platform = utils.getDevicePlatform();
        /*
         * Check Is Mobile - add 'is-mobile' class to div 'page'
         */
        $page.toggleClass("is-mobile", utils.isMobile());
        $page.addClass(platform);
        /*
         * Init Scroll Detect - add class 'is-scrolled' to div 'page'
         */
        $(window).on("scroll", function () {
            var scrollTop = $(this).scrollTop();

            if (scrollTop > 1 && $page.hasClass("is-scrolled")) {
                return;
            }

            $page.toggleClass("is-scrolled", scrollTop > 1);
        });
    }

    /*
     * Init Login Open Close
     */
    function initLoginOpenClose() {
        $("#globalLogin")
            .on("shown.bs.collapse", function (ev) {
                // $("header.header > .container").addClass("hidden-xs hidden-sm");
                $(ev.target).find("input").eq(0).focus();
            })
            .on("hidden.bs.collapse", function () {
                $("header.header > .container").removeClass("hidden-xs").removeClass("hidden-sm");
                setTimeout(function () {
                    $(".login-btn:visible").focus();
                }, 1000);
            });
    }

    /*
     * Init Card Open Close
     */
    function initCardOpenClose() {
        $(".card-content-item").not(".ko-open-close").dpOpenClose({
            opener: ".card-content-item-opener",
            classOpened: "is-open",
            contentBlock: ".card-content-item-block",
            duration: 300 // ms
        });
    }

    /*
     * Init Card Plan Open Close
     */
    function initCardPlanOpenClose() {
        $(".card-plan-box").not(".ko-open-close").dpOpenClose({
            opener: ".card-plan-box-opener",
            classOpened: "is-open",
            contentBlock: ".card-plan-box-content",
            duration: 300 // ms
        });
    }

    /*
     * Init Disclaimer Open Close
     */
    function initDisclaimerOpenClose() {
        var openClose = $(".disclaimer-tool")
                .dpOpenClose({
                    opener: ".disclaimer-tool-opener",
                    classOpened: "open",
                    contentBlock: ".disclaimer-tool-slide",
                    duration: 300 // ms
                })
                .data("dpOpenClose"),
            closeBtn = $(".disclaimer-tool-footer-opener");

        closeBtn.on("click", function (e) {
            e.preventDefault();
            openClose.closeBlock();
        });
    }

    /*
     * Init Filter Open Close
     */
    function initFilterOpenClose() {
        $(".filter-box").dpOpenClose({
            opener: ".filter-box-opener",
            classOpened: "open",
            contentBlock: ".filter-box-slide",
            duration: 300 // ms
        });
    }

    /*
     * Init Form Info Open Close
     */
    function initFormInfoOpenClose() {
        $(".filter-box-form-info").dpOpenClose({
            opener: ".filter-box-form-info-opener > a",
            classOpened: "open",
            contentBlock: ".filter-box-form-info-slide",
            duration: 300 // ms
        });
    }

    /*
     * Init Actions Open Close
     */
    function initActionsOpenClose() {
        var actionsOpenClose;

        $(window).on("screenbreakpoint", onResize);

        onResize();

        function init() {
            actionsOpenClose = $(".action-links")
                .dpOpenClose({
                    opener: ".action-links-opener",
                    classOpened: "is-open",
                    contentBlock: ".action-links-slide",
                    duration: 300 // ms
                })
                .data("dpOpenClose");
        }

        function onResize() {
            if (window.innerWidth <= 767 && !actionsOpenClose) {
                init();
            } else if (window.innerWidth > 767 && actionsOpenClose) {
                actionsOpenClose.destroy();
                actionsOpenClose = null;
            }
        }
    }

    /*
     * init Mobile menu
     */
    function initOneNavOpenAtATime() {
        var $mobileHeaderMenu = $("#mobileHeaderMenu");
        $mobileHeaderMenu
            .on("show.bs.collapse", function (e) {
                if ($(this).is(e.target)) {
                    $("body, html").addClass("lock-scroll");
                }
            })
            .on("hidden.bs.collapse", function (e) {
                if ($(this).is(e.target)) {
                    $("body, html").removeClass("lock-scroll");
                }
            });
        $mobileHeaderMenu.find(".collapse-container").on("show.bs.collapse", function () {
            $mobileHeaderMenu.find(".collapse-container").collapse("hide"); // hide the other navs
        });
        // .on("shown.bs.collapse", function () {
        //     $("header.header > .container").addClass("hidden-xs hidden-sm");
        // })
        // .on("hidden.bs.collapse", function () {
        //     $("header.header > .container").removeClass("hidden-xs hidden-sm");
        // });
    }

    /*
     * Init Accordion
     */
    function initAccordion() {
        var accordionWrapper = $(".accordion");
        var accordions = accordionWrapper
            .dpAccordion({
                opener: ".accordion-item-opener",
                blockContainer: ">.accordion-item",
                active: 1,
                classOpened: "is-open",
                expand: true,
                collapsible: true,
                contentBlock: ".accordion-item-content"
            })
            .data("dpAccordion");
        var btnExpand = accordionWrapper.find(".btn-expand");

        btnExpand.on("click", function (e) {
            var target = $(e.target);
            var isActive = target.hasClass("active");
            e.preventDefault();

            target.toggleClass("active");

            if (isActive) {
                accordions.closeAllBlocks();
                return;
            }
            accordions.openAllBlocks();
        });
    }

    /*
     * init Bootstrap Select
     */
    function initBootstrapSelect() {
        // Available options - https://silviomoreto.github.io/bootstrap-select/options/
        if ($(this).width() <= constants.BREAKPOINT_MOBILE_SCREEN) {
            if ($("select.bselect").closest(".lookup-tools-header").length > 0) {
                $("select.bselect").selectpicker({
                    mobile: false,
                    dropupAuto: true
                });
            } else if (
                $("select.bselect").parent().hasClass("formulary-dropdown") ||
                $("select.bselect").parent().hasClass("select-wrapper-native") ||
                $("select.bselect").parent().hasClass(".bselect") ||
                ($("select.bselect").length > 1 && $("select.bselect").attr("data-bind") !== undefined && $("select.bselect").data("bind").indexOf("selectPicker") !== -1)) {
                // do nothing
            } else {
                $("select.bselect").wrap("<div class='select-wrapper-native'></div>");
            }
        } else {
            $("select.bselect").selectpicker({
                mobile: true,
                dropupAuto: true
            });
        }

        $(".hcr-meds-container .bselect").on("changed.bs.select", function (e, clickedIndex, isSelected, previousValue) {
            var scan = window.scan || {};
            scan.bselected = true;
        });
        $(".hcr-meds-container .bselect .dropdown-menu").on("click", function (e) {
            var scan = window.scan || {};
            scan.bselected = true;
            if ($(e.target).closest("a").text().length > 0) {
                scan.bselectObservable.valueHasMutated(); // this is set in healthCheckRecordViewModel
            }
        });
    }

    /*
     * init Placeholder plugin
     */
    function initPlaceholder() {
        $("input, textarea").placeholder();
    }

    /*
     * init Bootstrap alert plugin
     */
    function initBootstrapAlert() {
        var alertList = document.querySelectorAll(".alert");
        alertList.forEach(function (alert) {
            new bootstrap.Alert(alert);
        });
    }

    /*
     * init Slick Gallery plugin
     */
    function initGallery() {
        var galleryHolder = $(".comparison-table-slider-holder");

        function initSlick() {
            scanTranslations.getInstance().then(function (scanTranslationInstance) {
                // if galleryHolder has > 3 items
                if (galleryHolder.find(".comparison-table-column").length < 3) {
                    galleryHolder.slick({
                        prevArrow: '<button type="button" class="slick-prev"><span class="icon-angle-left"><span class="hide-for-screen-reader">' + scanTranslationInstance.translate("sr_previous") + "</span></span></button>",
                        nextArrow: '<button type="button" class="slick-next"><span class="icon-angle-right"><span class="hide-for-screen-reader">' + scanTranslationInstance.translate("sr_next") + "</span></span></button>",
                        infinite: false,
                        slidesToShow: 2
                    });
                    // else if galleryHolder has < 3 items
                } else {
                    galleryHolder.slick({
                        prevArrow: '<button type="button" class="slick-prev"><span class="icon-angle-left"><span class="hide-for-screen-reader">' + scanTranslationInstance.translate("sr_previous") + "</span></span></button>",
                        nextArrow: '<button type="button" class="slick-next"><span class="icon-angle-right"><span class="hide-for-screen-reader">' + scanTranslationInstance.translate("sr_next") + "</span></span></button>",
                        infinite: false,
                        slidesToShow: 3
                    });
                }
            });
        }

        function checkForInit() {
            var windowWidth = $(this).width(),
                initializedSlick = galleryHolder.hasClass("slick-initialized");
            if (windowWidth > 767 && !initializedSlick) {
                initSlick();
            }

            if (windowWidth < 768 && initializedSlick) {
                galleryHolder.slick("unslick");
            }
        }

        $(window).on("resize orientationchange", checkForInit);

        checkForInit();
    }

    /*
     * init Slick Gallery plugin
     */
    function initPolicySearchGallery() {
        var galleryHolder = $(".policy-table-slider-holder"),
            buttonHolder = $(".policy-table-button-holder"),
            prevArrow = buttonHolder.find(".slick-prev"),
            nextArrow = buttonHolder.find(".slick-next"),
            mobileSize = constants.BREAKPOINT_MOBILE_SCREEN;

        function initSlick() {
            galleryHolder.slick({
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                slidesToShow: 3,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }

        function checkForInit() {
            var windowWidth = $(this).width(),
                initializedSlick = galleryHolder.hasClass("slick-initialized");
            if (windowWidth <= mobileSize && !initializedSlick) {
                initSlick();
            }

            if (windowWidth > mobileSize && initializedSlick) {
                galleryHolder.slick("unslick");
            }
        }

        $(window).on("resize orientationchange", checkForInit);

        checkForInit();
    }

    /*
     * init Open Close plugin for plans
     */
    function initExtendOpenClose() {
        var holder = $(".plan-finder"),
            openers = holder.find(".block-opener"),
            openedBlocks = holder.find(".block-open"),
            openersList = holder.find(".plan-finder-lists"),
            openedClass = "opened",
            speedClose = 350; //ms

        openedBlocks.height(0).attr("aria-expanded", "false").attr("tabindex", "-1").find("a, input, button").attr("tabindex", "-1");
        openersList.attr("aria-expanded", "true").attr("tabindex", "").find("a, input, button").attr("tabindex", "");

        openers.each(function (index, elem) {
            $(elem).on("click", function (e) {
                var cloneEl = openedBlocks.eq(index).clone().css({ height: "auto" }).appendTo("body"),
                    elHeight = cloneEl.css("height");

                e.preventDefault();
                cloneEl.remove();

                if (!openedBlocks.eq(index).hasClass(openedClass)) {
                    openedBlocks
                        .eq(index)
                        .attr("aria-expanded", "true")
                        .addClass(openedClass)
                        .animate({ height: elHeight }, speedClose, function () {
                            $(this).height("");
                        })
                        .attr("tabindex", "")
                        .find("a, input, button")
                        .attr("tabindex", "");

                    openersList
                        .attr("aria-expanded", "false")
                        .removeClass(openedClass)
                        .animate({ height: 0 }, speedClose, function () {
                            $.noop();
                        })
                        .attr("tabindex", "-1")
                        .find("a, input, button")
                        .attr("tabindex", "-1");
                }
            });
        });

        $(".plan-finder-close").on("click", function (e) {
            var openerEl = openersList.clone().css({ height: "auto" }).appendTo("body"),
                elHeight = openerEl.css("height");

            e.preventDefault();
            openerEl.remove();

            $(this).parents(".block-open").attr("aria-expanded", "false").removeClass(openedClass).animate({ height: 0 }, speedClose).attr("tabindex", "-1").find("a, input, button").attr("tabindex", "-1");
            openersList
                .attr("aria-expanded", "true")
                .addClass(openedClass)
                .animate({ height: elHeight }, speedClose, function () {
                    $(this).height("");
                })
                .attr("tabindex", "")
                .find("a, input, button")
                .attr("tabindex", "");
        });
    }

    /*
     * init Slick Gallery Same Height plugin
     */
    function initGallerySameHeight() {
        function setRowHeight() {
            var holder = $(".comparison-table"),
                fixedColItems = holder.find(".comparison-table-fixed-column .comparison-table-column-cell"),
                galleryCols = holder.find(".comparison-table-column"),
                windowWidth = $(window).width();

            fixedColItems.each(function (index, elem) {
                var max = 0,
                    arrHeight = [],
                    rowArr = [];

                rowArr = galleryCols.find(".comparison-table-column-cell:eq(" + index + ")").add(elem);
                rowArr.outerHeight("");
                if (windowWidth > 767) {
                    arrHeight = rowArr.map(function (ind, el) {
                        return $(el).outerHeight();
                    });
                    max = Math.max.apply(Math, arrHeight);
                    rowArr.outerHeight(max);
                }
            });
        }

        setRowHeight();
        $(window).on("resize orientationchange", function () {
            setRowHeight();
        });
    }

    // init Slick Gallery Same Height
    function initPolicyGallerySameHeight() {
        function setRowHeight() {
            var holder = $(".policy-table"),
                fixedColItems = holder.find(".policy-table-fixed-column .policy-table-fixed-cell"),
                galleryCols = holder.find(".policy-table-slide-column"),
                windowWidth = $(window).width();

            fixedColItems.each(function (index, elem) {
                var max = 0,
                    arrHeight = [],
                    rowArr = [];

                rowArr = galleryCols.find(".policy-table-fixed-cell:eq(" + index + ")").add(elem);
                rowArr.outerHeight("");
                if (windowWidth <= 767) {
                    arrHeight = rowArr.map(function (ind, el) {
                        return $(el).outerHeight();
                    });
                    max = Math.max.apply(Math, arrHeight);
                    rowArr.outerHeight(max);
                }
            });
        }

        setRowHeight();
        $(window).on("resize orientationchange", function () {
            setRowHeight();
        });
    }

    function initPlanMaterilasOpenClose() {
        $(".card-example").dpOpenClose({
            opener: ".card-example-opener",
            classOpened: "opened",
            contentBlock: ".card-example-slide"
        });
    }

    function initCardExampleOpenClose() {
        $(".materials-box").dpOpenClose({
            opener: ".materials-box-opener",
            classOpened: "opened",
            contentBlock: ".materials-box-slide"
        });
    }

    function initModalFunctions() {
        var $modalTrigger = $('[data-bs-toggle="modal"]');
        if ($modalTrigger.length > 0) {
            var $modal = $(".modal");
            $modal.on("hidden.bs.modal", function (e) {
                var $iframes = $(e.target).find("iframe");
                $iframes.each(function (index, iframe) {
                    $(iframe).attr("src", $(iframe).attr("src"));
                });
                var $videos = $(e.target).find("video");
                $videos.each(function (index, $video) {
                    $video.pause();
                });
            });
            $("#uploadFileModal")
                .on("show.bs.modal", function (event) {
                    const $button = $(event.relatedTarget);
                    const fileName = $button.data("filename");
                    const fileTitle = $button.data("title");
                    const $modal = $(this);
                    if (fileName) {
                        $modal.find("form").addClass("edit");
                        $modal.find(".filename").text(fileName);
                        $modal.find('[name="title"]').val(fileTitle);
                    }
                })
                .on("hide.bs.modal", function () {
                    const $modal = $(this);
                    $modal.find("form").removeClass("edit");
                    $modal.find(".filename").text("");
                    $modal.find('[name="title"]').val("");
                });
            $("#editFileModal")
                .on("show.bs.modal", function (event) {
                    const $button = $(event.relatedTarget);
                    const fileName = $button.data("filename");
                    const fileTitle = $button.data("title");
                    const $modal = $(this);
                    if (fileName) {
                        $modal.find("form").addClass("edit");
                        $modal.find(".filename").text(fileName);
                        $modal.find('[name="title"]').val(fileTitle);
                    }
                })
                .on("hide.bs.modal", function () {
                    const $modal = $(this);
                    $modal.find("form").removeClass("edit");
                    $modal.find(".filename").text("");
                    $modal.find('[name="title"]').val("");
                });
        }
    }

    //setupSmoothScroll
    function initSmoothScroll() {
        var anchorLink = $(".anchor-link");
        if (anchorLink.length > 0) {
            anchorLink.on("click", function (event) {
                event.preventDefault();
                var offset = $($(this).attr("href")).offset().top;
                var $offsetTarget = $($(this).attr("href"));
                // offset anchor linking
                $("html, body").animate({ scrollTop: offset }, 500, function () {
                    // add focus to anchor
                    $offsetTarget.attr("tabindex", -1).focus();
                });
            });
        }
        var backToTop = $(".back-to-top");
        if (backToTop.length > 0) {
            backToTop.on("click", function (event) {
                event.preventDefault();
                // scroll top
                $("html, body").animate({ scrollTop: "0" }, 500, function () {
                    // add focus
                    $("body").attr("tabindex", -1).focus();
                });
                var lookupToolsContainerFilters = $(".lookup-tools-container-filters");
                if (lookupToolsContainerFilters.length > 0) {
                    lookupToolsContainerFilters[0].scrollTop = 0;
                }
            });
        }
    }

    function initTableSort() {
        $(".document-table table:not(.notifications)").DataTable({
            paging: false,
            searching: false,
            info: false,
            order: [],
            style: "",
            columns: [{ orderable: true }, { orderable: true }, { orderable: false }]
        });
    }

    function initPortalTabNav() {
        var $tabNavContainer = $(".tab-nav-container");
        var $collapseToggle = $tabNavContainer.find(".collapse-toggle");
        var activeText = $tabNavContainer.find("li.active a").text();
        $collapseToggle.text(activeText);

        if ($(".profile-preference-inner .tab-nav-container").length > 0) {
            $(this).click(function () {
                var activeText = $tabNavContainer.find("li.active a").text();
                $collapseToggle.text(activeText);
            });
        }
    }

    function initProfileCollapse() {
        $(".well .close").each(function () {
            $(this).on("click", function () {
                $(this).closest(".collapse").collapse("hide");
            });
        });
    }

    function initFilterBoxFilters() {
        var $zipCheck = $(".filter-box .zip-check");
        var $filterResultsCheckbox = $('.filter-box .filter-results input[type="checkbox"]');

        $zipCheck.on("keyup change", function () {
            if (
                $zipCheck.filter(function () {
                    return $(this).val();
                }).length > 0
            ) {
                $(this).parent().find(".bselect").removeAttr("disabled").removeClass("default-disabled").removeClass("disabled");
                $(this).parent().find(".dropdown-toggle").removeAttr("tabindex").removeClass("disabled");
            }
        });

        $filterResultsCheckbox.on("click", function () {
            if ($(this).prop("checked")) {
                $(this).parent().addClass("checked");
            } else {
                $(this).parent().removeClass("checked");
            }
        });
        $filterResultsCheckbox.on("focus", function () {
            $(this).parent().addClass("focus");
        });
        $filterResultsCheckbox.on("blur", function () {
            $(this).parent().removeClass("focus");
        });
    }

    function initPlanFinderQuestions() {
        var dataLayer = window.dataLayer || [];
        window.scan = window.scan || {};
        var $planFinderQuestion = $(".plan-finder-questions .question");
        var $planFinderQuestionBtnSelected = $(".plan-finder-questions .btn.has-selection");
        var $planFinderQuestionBtnUnselected = $(".plan-finder-questions .btn.unselected");
        var $planFinderTextQuestion = $(".plan-finder-questions .textquestion");
        var $planFinderSelectedChoices = $("#planFinderSelectedChoices");
        var $planFinderSkipQuestion = $(".plan-finder-questions .skip-question");

        if ($(".setHotJarVpv").length > 0) {
            window.hj =
                window.hj ||
                function () {
                    (hj.q = hj.q || []).push(arguments);
                };
            window.hj("vpv", $(".setHotJarVpv").data("hotjarvpv"));
        }

        if ($planFinderQuestion.parents().is(".multiselect")) {
            $planFinderQuestion.on("click", function (e) {
                if ($(this).data("exclusive") === "True") {
                    if ($(this).is('[aria-pressed*="true"]')) {
                        $(this).attr("aria-pressed", "false");
                    } else {
                        $planFinderQuestion.attr("aria-pressed", "false");
                        $(this).attr("aria-pressed", "true");
                    }
                } else {
                    if ($(this).is('[aria-pressed*="true"]')) {
                        $(this).attr("aria-pressed", "false");
                    } else {
                        $('[data-exclusive="True"]').attr("aria-pressed", "false");
                        $(this).attr("aria-pressed", "true");
                    }
                }
                if ($planFinderQuestion.is('[aria-pressed*="true"]')) {
                    $planFinderQuestionBtnUnselected.hide();
                    $planFinderQuestionBtnSelected.show();
                    //$planFinderSkipQuestion.hide();
                } else {
                    $planFinderQuestionBtnUnselected.show();
                    $planFinderQuestionBtnSelected.hide();
                    //$planFinderSkipQuestion.show();
                }
                e.preventDefault();
            });
        } else {
            $planFinderQuestion.on("click", function (e) {
                if ($(this).is('[aria-pressed*="true"]')) {
                    $(this).attr("aria-pressed", "false");
                } else {
                    $planFinderQuestion.attr("aria-pressed", "false");
                    $(this).attr("aria-pressed", "true");
                }
                if ($planFinderQuestion.is('[aria-pressed*="true"]')) {
                    $planFinderQuestionBtnUnselected.hide();
                    $planFinderQuestionBtnSelected.show();
                    //$planFinderSkipQuestion.hide();
                } else {
                    $planFinderQuestionBtnUnselected.show();
                    $planFinderQuestionBtnSelected.hide();
                    //$planFinderSkipQuestion.show();
                }
                e.preventDefault();
            });
        }
        $planFinderTextQuestion.on("keyup", function (e) {
            if ($planFinderTextQuestion.val() === "") {
                $planFinderQuestionBtnUnselected.show();
                $planFinderQuestionBtnSelected.hide();
            } else {
                $planFinderQuestionBtnUnselected.hide();
                $planFinderQuestionBtnSelected.show();
            }
        });
        $planFinderTextQuestion.on("keypress", function (e) {
            if (e.which === 13) {
                $("#planFinderForm").submit();
                return false;
            }
            return true;
        });
        $("#planFinderForm").on("submit", function (e) {
            $('.plan-finder-questions [aria-pressed*="true"]').each(function () {
                var selectedChoice = "|" + $(this).data("choice_val") + "|";
                var otherSelections = $planFinderSelectedChoices.val();
                $planFinderSelectedChoices.val(otherSelections + selectedChoice);
            });
            if (window.scan.planFinderGaEvent !== "") {
                var eventLabel = "";
                if ($planFinderSelectedChoices.val() !== "") {
                    eventLabel = $planFinderSelectedChoices.val();
                } else if ($("#planFinderSelect option:selected").text() !== "") {
                    eventLabel = $("#planFinderSelect option:selected").text();
                } else if ($("#planFinderText").val() !== "") {
                    eventLabel = $("#planFinderText").val();
                }
                if (eventLabel !== null && eventLabel !== undefined && eventLabel !== "") {
                    //cleanup delimiters
                    if (eventLabel.charAt(0) === "|") {
                        eventLabel = eventLabel.substr(1);
                    }
                    if (eventLabel.slice(-1) === "|") {
                        eventLabel = eventLabel.substr(0, eventLabel.length - 1);
                    }
                    eventLabel = eventLabel.replace(/\|\|/g, ", ");

                    dataLayer.push({
                        event: window.scan.planFinderGaEvent,
                        eventCategory: window.scan.planFinderGaEventCategory,
                        eventAction: window.scan.planFinderGaEventAction,
                        eventLabel: eventLabel
                    });
                }
            }
            var urlParams = urlParameters.read();

            var path = encodeURIComponent(getPropertyCaseInsensitive(urlParams, "path"));
            if (path) {
                var action = $("#planFinderForm").attr("action");
                $("#planFinderForm").attr("action", action + "?path=" + path);
            }
        });
        $(".plans-form").on("submit", function (e) {
            dataLayer.push({
                event: "gaEvent",
                eventCategory: "Plan Search",
                eventAction: "Zip Code",
                eventLabel: $("#findplanzipcode").val()
            });
        });

        $("#planFinderSelect").on("change", function () {
            $("#planFinderForm").submit();
        });
        $planFinderSkipQuestion.click(function (e) {
            // clear any selections
            $('.plan-finder-questions [aria-pressed*="true"]').each(function () {
                $(this).attr("aria-pressed", "false");
            });
            $planFinderSelectedChoices.val("");
            $("#planFinderText").val("");
            $("#planFinderSelect").val([]);

            dataLayer.push({
                event: window.scan.planFinderGaEvent,
                eventCategory: window.scan.planFinderGaEventCategory,
                eventAction: window.scan.planFinderGaEventAction,
                eventLabel: "question skipped"
            });
        });
        // in case the field is pre-populated already
        if ($planFinderTextQuestion.length > 0 && $planFinderTextQuestion.val() !== "") {
            $planFinderQuestionBtnUnselected.hide();
            $planFinderQuestionBtnSelected.show();
        }
        if ($planFinderQuestion.length > 0) {
            if ($planFinderQuestion.is('[aria-pressed*="true"]')) {
                $planFinderQuestionBtnUnselected.hide();
                $planFinderQuestionBtnSelected.show();
                //$planFinderSkipQuestion.hide();
            } else {
                $planFinderQuestionBtnUnselected.show();
                $planFinderQuestionBtnSelected.hide();
                //$planFinderSkipQuestion.show();
            }
        }
    }

    function initPlanFinderHelp() {
        var $planFinderHelp = $(".plan-finder-help");
        $planFinderHelp
            .find("> figure")
            .on("click enter", function (e) {
                $planFinderHelp.addClass("active");
                $planFinderHelp.find(".message").attr("aria-hidden", "false").attr("tabindex", "0").focus();
                e.preventDefault();
            })
            .on("keypress", function (e) {
                if (e.which === 13) {
                    $(this).trigger("enter");
                }
            });
        $planFinderHelp.find(".close").on("click", function (e) {
            $planFinderHelp.removeClass("active");
            $planFinderHelp.find(".message").attr("aria-hidden", "true").removeAttr("tabindex");
            // $planFinderHelp.find('> figure').focus();
            e.preventDefault();
        });
    }

    function initPlanFinderCompareBlocks() {
        var $planFinderCompare = $(".plan-finder-container .plan-finder-compare");
        if ($planFinderCompare.find(".col-sm-4").length === 1) {
            $planFinderCompare.find(".row").removeClass("row-flex-wrap");
            $planFinderCompare.find(".col-sm-4").css({ "margin-left": "auto", "margin-right": "auto", float: "none" });
            // $planFinderCompare.find('.col-sm-4').attr({'class' : 'col-sm-6'});
            $planFinderCompare.find(".form-item").hide();
        }
    }

    function initStickyCompare() {
        var $planFinderCompareBlocks = $(".plan-finder-compare");
        var $stickyTrigger = $("#stickyTrigger");

        if ($planFinderCompareBlocks.length > 0) {
            function stickyCompare() {
                var compareBlock = $planFinderCompareBlocks.find("input:checkbox:checked").length;
                if (compareBlock >= 2) {
                    $stickyTrigger.show();
                } else {
                    $stickyTrigger.hide();
                }
                $stickyTrigger.find(".sticky-compare .compare-number").text("(" + compareBlock + ")");
            }

            // if checked run function
            if ($planFinderCompareBlocks.find("input:checkbox").is(":checked")) {
                stickyCompare();
            }

            // if clicked run function
            $planFinderCompareBlocks.find("input:checkbox").on("click", function () {
                stickyCompare();
            });
        }

        if ($stickyTrigger.length > 0) {
            var controller = new ScrollMagic.Controller();

            // If mobile device or personalization banner is detected...
            if ($(".page").is(".is-mobile") || $("#personalization-banner-footer").length > 0) {
                controller.destroy();
                $(".sticky-compare").removeClass("stuck");
            } else {
                // sticky nav slide up/down on trigger
                new ScrollMagic.Scene({
                    duration: 0, // pin element for entire duration
                    triggerElement: "#stickyTrigger",
                    triggerHook: "onEnter", // don't trigger until triggerElement hits the bottom of the viewport
                    offset: $stickyTrigger.outerHeight(),
                    reverse: true // allows the effect to trigger when scrolled in the reverse direction
                })
                    // .setPin(".sticky-compare") // the element we want to pin
                    .on("enter", function (event) {
                        $(".sticky-compare").removeClass("stuck");
                    })
                    .on("leave", function (event) {
                        $(".sticky-compare").addClass("stuck");
                    })
                    .addTo(controller);
            }
        }

        var $planFinderCompareButton = $stickyTrigger.find("a");
        $planFinderCompareButton.on("click", function () {
            var identList = "";
            $planFinderCompareBlocks.find("input:checkbox:checked").each(function () {
                if (identList.length > 0) {
                    identList = identList + "&";
                }
                identList = identList + "ids=" + $(this).data("plan_ident");
            });
            window.location.href = window.scan.planFinderComparisonUrl + "?" + identList;
        });
    }

    function equalHeights() {
        // create equal heights for flexbox fallback

        if ($(".plan-finder-compare").length > 0) {
            // equal heights for system-service links
            var $compareBoxes = $(".plan-finder-compare .compare-wrapper");
            var elementHeightsService = $compareBoxes
                .map(function () {
                    return $(this).height();
                })
                .get();
            var maxHeightService = Math.max.apply(null, elementHeightsService);
            $compareBoxes.height(maxHeightService);
        }

        if ($(".detail-cost-callouts").length > 0) {
            // equal heights for detail cost links
            var $detailCostBoxes = $(".detail-cost-callouts .cost-content");
            var detailHeightsService = $detailCostBoxes
                .map(function () {
                    return $(this).height();
                })
                .get();
            var maxDetailHeightService = Math.max.apply(null, detailHeightsService);
            $detailCostBoxes.height(maxDetailHeightService);
        }
        if ($(".language-benefits").length > 0) {
            // equal heights for language benefits links
            var $languageBoxes = $(".language-benefits .benefit-btn");
            var languageHeightsService = $languageBoxes
                .map(function () {
                    return $(this).height();
                })
                .get();
            var maxLanguageHeightService = Math.max.apply(null, languageHeightsService);
            $languageBoxes.height(maxLanguageHeightService);
        }

        if ($(".enrollment-callout").length > 0) {
            // equal heights for language benefits links
            var $enrollmentBoxes = $(".enrollment-callout .enrollment-content");
            var enrollmentHeightsService = $enrollmentBoxes
                .map(function () {
                    return $(this).height();
                })
                .get();
            var maxEnrollmentHeightService = Math.max.apply(null, enrollmentHeightsService);
            $enrollmentBoxes.height(maxEnrollmentHeightService);
        }

        if ($(".search-landing-container .help-block-item-container").length > 0) {
            // equal heights for language benefits links
            var $searchHelpBlockItem = $(".search-landing-container .help-block-item-container .help-block-item");
            var $searchHelpBlockItemHeights = $searchHelpBlockItem
                .map(function () {
                    return $(this).height();
                })
                .get();
            var maxSearchHelpBlockItemHeights = Math.max.apply(null, $searchHelpBlockItemHeights);
            $searchHelpBlockItem.height(maxSearchHelpBlockItemHeights);
        }
    }

    function resetHeights() {
        // reset heights for flexbox fallback

        if ($(".plan-finder-compare").length > 0) {
            // equal heights for system-service links
            var $compareBoxes = $(".plan-finder-compare .compare-wrapper");
            $compareBoxes.css({ height: "auto" });
            equalHeights();
        }
        if ($(".detail-cost-callouts").length > 0) {
            // equal heights for system-service links
            var $detailCostBoxes = $(".detail-cost-callouts .cost-content");
            $detailCostBoxes.css({ height: "auto" });
            equalHeights();
        }
        if ($(".language-benefits").length > 0) {
            // equal heights for system-service links
            var $languageBoxes = $(".language-benefits .benefit-btn");
            $languageBoxes.css({ height: "auto" });
            equalHeights();
        }
        if ($(".enrollment-callout").length > 0) {
            // equal heights for system-service links
            var $enrollmentBoxes = $(".enrollment-callout .enrollment-content");
            $enrollmentBoxes.css({ height: "auto" });
            equalHeights();
        }
        if ($(".search-landing-container .help-block-item-container").length > 0) {
            // equal heights for system-service links
            var $searchHelpBlockItem = $(".search-landing-container .help-block-item-container .help-block-item");
            $searchHelpBlockItem.css({ height: "auto" });
            equalHeights();
        }
    }

    function tableShowMore() {
        if ($(".detail-table").length > 0) {
            $("#click").click(function () {
                $(".detail-table").find(".no-show").toggle().animate();
                $(this)
                    .html(function (_, htm) {
                        scanTranslations.getInstance().then(function (scanTranslationInstance) {
                            return htm == scanTranslationInstance.translate("more_benefits") ? scanTranslationInstance.translate("less_benefits") : scanTranslationInstance.translate("more_benefits");
                        });
                    })
                    .toggleClass("show-more show-less");
            });
        }
    }

    function passwordValidation() {
        var $passwordVerification = $("#passwordVerification");
        if ($passwordVerification.length > 0) {
            // get the password input field that this password verification instance is associated with.
            var passwordElement = $("#" + $passwordVerification.attr("aria-describedby"));

            var rules = [
                {
                    messageElement: $passwordVerification.find("#passwordLength"),
                    validityCheck: function (val) {
                        return val.length >= 8;
                    }
                },
                {
                    messageElement: $passwordVerification.find("#passwordLetter"),
                    validityCheck: function (val) {
                        return val.match(utils.passwordLetterRegex);
                    }
                },
                {
                    messageElement: $passwordVerification.find("#passwordNumber"),
                    validityCheck: function (val) {
                        return val.match(utils.passwordNumberRegex);
                    }
                },
                {
                    messageElement: $passwordVerification.find("#passwordSpecial"),
                    validityCheck: function (val) {
                        return val.match(utils.passwordSpecialCharacterRegex);
                    }
                },
                {
                    messageElement: $passwordVerification.find("#passwordValidChars"),
                    validityCheck: function (val) {
                        return val.match(utils.passwordValidCharsRegex);
                    }
                }
            ];

            // iterates through the rules and marks each as satisfied or unsatisfied.
            var updateDisplay = function () {
                var password = passwordElement.val();

                for (var i in rules) {
                    if (rules.hasOwnProperty(i)) {
                        var rule = rules[i];
                        if (rule.validityCheck(password)) {
                            rule.messageElement.removeClass("invalid").addClass("valid").attr("aria-invalid", "false");
                        } else {
                            rule.messageElement.removeClass("valid").addClass("invalid").attr("aria-invalid", "true");
                        }
                    }
                }
            };

            // update the display on page load (in case an existing password is filled by a password mgr, etc.)
            // and also when the user makes a change.
            passwordElement.keyup(updateDisplay);
            updateDisplay();
        }
    }

    function skipNav() {
        // bind a click event to the 'skip-nav' link and give focus
        $("a.skip").click(function () {
            var skipTo = "#" + this.href.split("#")[1];
            $(skipTo)
                .attr("tabindex", -1)
                .on("blur focusout", function () {
                    $(this).removeAttr("tabindex");
                })
                .focus();
        });
    }

    function initPopover() {
        var $popoverTrigger = $('[data-bs-toggle="popover"]');
        if ($popoverTrigger.length > 0) {
            $popoverTrigger.popover();
            $popoverTrigger.each(function () {
                $(this).on("show.bs.popover", function () {
                    $(this).addClass("active");
                });
                $(this).on("hide.bs.popover", function () {
                    $(this).removeClass("active");
                });
            });
        }
    }

    function initConAcctAddAccountCollapsible() {
        var $conAcctAddAccountMenu = $("#conAcctAddAnotherAccount");

        function allInputsHaveValue() {
            return (
                $(".consolidated-accounts-container .form input").filter(function () {
                    return $.trim($(this).val()).length === 0;
                }).length === 0
            );
        }

        function checkConAcctValidation() {
            if ($('.consolidated-accounts-container .form input[type="checkbox"]').not(":checked").length === 0) {
                // if all checkboxes are checked
                // console.log("all checkboxes");
                if (allInputsHaveValue()) {
                    // console.log("all input fields");
                    $(".btn-confirmation").removeAttr("disabled");
                } else {
                    $(".btn-confirmation").not(".btn-confirmation.add-account-collapsed").attr("disabled", "disabled");
                }
            } else {
                // console.log("no checkboxes");
                $(".btn-confirmation").not(".btn-confirmation.add-account-collapsed").attr("disabled", "disabled");
            }
        }

        checkConAcctValidation();

        $(".consolidated-accounts-container .form input").on("click", function () {
            checkConAcctValidation();
        });
        $(".consolidated-accounts-container .form input").on("change", function () {
            checkConAcctValidation();
        });
        $(".consolidated-accounts-container .form input").on("blur", function () {
            checkConAcctValidation();
        });
        $(".consolidated-accounts-container .form input").keyup(function () {
            checkConAcctValidation();
        });

        $conAcctAddAccountMenu.on("show.bs.collapse", function () {
            $(".add-account-expanded").show();
            $(".add-account-collapsed").hide();
            $(".form-error-text").show();
            $(".btn-confirmation").not(".btn-confirmation.add-account-collapsed").attr("disabled", "disabled");
            checkConAcctValidation();
        });

        $conAcctAddAccountMenu.on("hide.bs.collapse", function () {
            $(".add-account-expanded").hide();
            $(".add-account-collapsed").show();
            $(".form-error-text").hide();
            $(".btn-confirmation").not(".btn-confirmation.add-account-collapsed").attr("disabled", "disabled");
        });
    }

    function lookupToolsFilterOverlay() {
        var $triggerMenu = $(".lookup-tools-page-options-filters .trigger-filter-overlay");
        var $menu = $(".lookup-tools-container .lookup-tools-container-filters");
        var $menuClose = $(".lookup-tools-container .lookup-tools-container-filters .close-menu");

        if ($triggerMenu.length > 0) {
            $triggerMenu.on("click", function (e) {
                e.preventDefault();
                if ($triggerMenu.hasClass("active")) {
                    $triggerMenu.removeClass("active").attr("aria-expanded", false);
                    $("html, body").removeClass("no-scroll");
                    $menu.removeClass("show").attr("aria-hidden", true);
                    releaseKeyboardFocus();
                } else {
                    $triggerMenu.addClass("active").attr("aria-expanded", true);
                    $("html, body").addClass("no-scroll");
                    $menu.addClass("show").attr("aria-hidden", false);
                    trapKeyboardFocus();
                }
                e.preventDefault();
            });
            $menuClose.on("click", function (e) {
                $triggerMenu.removeClass("active").attr("aria-expanded", false);
                $("html, body").removeClass("no-scroll");
                $menu.removeClass("show").attr("aria-hidden", true);
                releaseKeyboardFocus();
                e.preventDefault();
            });

            function trapKeyboardFocus() {
                // Trap keyboard Focus
                var tabbable = $menu.find("select, input, textarea, button, a").filter(":visible");
                var firstTabbable = tabbable.first();
                var lastTabbable = tabbable.last();
                // set focus on first input
                firstTabbable.focus();
                // redirect last tab to first input
                lastTabbable.bind("keydown.tab", function (e) {
                    if (e.which === 9 && !e.shiftKey) {
                        e.preventDefault();
                        firstTabbable.focus();
                    }
                });
                // redirect first shift+tab to last input
                firstTabbable.bind("keydown.tab", function (e) {
                    if (e.which === 9 && e.shiftKey) {
                        e.preventDefault();
                        lastTabbable.focus();
                    }
                });
            }

            function releaseKeyboardFocus() {
                // Release keyboard Focus
                var tabbable = $menu.find("select, input, textarea, button, a").filter(":visible");
                var firstTabbable = tabbable.first();
                var lastTabbable = tabbable.last();
                // set focus on first input
                lastTabbable.unbind("keydown.tab");
                firstTabbable.unbind("keydown.tab");
            }
        }
    }

    function lookupToolsOverlay() {
        var $triggerMenu;
        var $menu;
        var $toggleDefinition;

        function openOverlayMenu(targetOverlayId) {
            var $targetOverlay = $("#" + targetOverlayId);
            if ($($targetOverlay).hasClass("active")) {
                $triggerMenu.removeClass("active").attr("aria-expanded", false);
                $("html, body").removeClass("no-scroll");
                $menu.hide().attr("aria-hidden", true);
                releaseKeyboardFocus();
            } else {
                $triggerMenu.addClass("active").attr("aria-expanded", true);
                $("html, body").addClass("no-scroll");
                $menu.css("display", "grid").attr("aria-hidden", false);
                trapKeyboardFocus();
                menuOverflow();

                $(window).resize(
                    utils.debounce(function () {
                        menuOverflow();
                    }, 250)
                );
            }
        }

        function closeMenu() {
            console.log("closing menu");
            $triggerMenu.removeClass("active").attr("aria-expanded", false).focus();
            $("html, body").removeClass("no-scroll");
            $menu.hide().attr("aria-hidden", true);
            releaseKeyboardFocus();
        }

        function menuOverflow() {
            var viewportHeight = $(window).height();
            var overflowHeaderHeight = $menu.find(".overlay-header").outerHeight();
            $menu.find(".overlay-overflow-container").css("height", viewportHeight - overflowHeaderHeight);
        }

        function trapKeyboardFocus() {
            // Trap keyboard Focus
            var tabbable = $menu.find("select, input, textarea, button, a").filter(":visible");
            var firstTabbable = tabbable.first();
            var lastTabbable = tabbable.last();
            // set focus on first input
            firstTabbable.focus();
            // redirect last tab to first input
            lastTabbable.bind("keydown.tab", function (e) {
                if (e.which === 9 && !e.shiftKey) {
                    e.preventDefault();
                    firstTabbable.focus();
                }
            });
            // redirect first shift+tab to last input
            firstTabbable.bind("keydown.tab", function (e) {
                if (e.which === 9 && e.shiftKey) {
                    e.preventDefault();
                    lastTabbable.focus();
                }
            });
        }

        function releaseKeyboardFocus() {
            // Release keyboard Focus
            var tabbable = $menu.find("select, input, textarea, button, a").filter(":visible");
            var firstTabbable = tabbable.first();
            var lastTabbable = tabbable.last();
            // set focus on first input
            lastTabbable.unbind("keydown.tab");
            firstTabbable.unbind("keydown.tab");
        }

        if ($(".trigger-filters-overlay").length) {
            $(document)
                .on("click", ".trigger-filters-overlay", function (e) {
                    e.preventDefault();
                    $triggerMenu = $(e.target).closest("a");
                    $menu = $("#" + $triggerMenu.attr("aria-controls"));
                    $toggleDefinition = $menu.find(".toggle-definitions");
                    openOverlayMenu($triggerMenu.attr("aria-controls"));
                })
                .on("click", ".update-filters-overlay .close-menu", function (e) {
                    e.preventDefault();
                    closeMenu();
                })
                .on("click", ".toggle-definitions", function (e) {
                    var $definitions = $menu.find(".definition");
                    if ($toggleDefinition.hasClass("active")) {
                        $toggleDefinition.removeClass("active").attr("aria-expanded", false);
                        $definitions.hide().attr("aria-hidden", true);
                    } else {
                        $toggleDefinition.addClass("active").attr("aria-expanded", true);
                        $definitions.show().attr("aria-hidden", false);
                    }
                    e.preventDefault();
                });
        }
    }

    function initToolTip() {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl);
        });
    }

    function initMemberPortalGuide() {
        var $checkbox = $(".card-block.guide .checkbox button");
        var $tabs = $(".guide-progress .tabs");
        var $guides = $(".guide-progress .card-block.guide");
        var $skipLinkDivs = $(".guide-progress .card-block.guide .guideskip");

        function updateProgressBar() {
            var totalCardGuides = $(".card-block.guide").length;
            var completedCardGuided = $(".card-block.guide.complete").length;
            var percentComplete = (completedCardGuided / totalCardGuides) * 100;
            var percentCompleteTrim = percentComplete.toFixed(0);
            var $progressBar = $(".guide-progress-indicator .progress");
            $progressBar.css({ width: percentCompleteTrim + "%" });
            $(".guide-progress-indicator .percent").html("(" + percentCompleteTrim + "%)");
        }

        function displayNextGuidedStep() {
            var $incompleteDivs = $guides.not(".complete");
            var $nextDiv = $guides.not(".complete, .skipped").first();

            $guides.removeClass("d-grid"); //.hide();

            if ($incompleteDivs.length > 0) {
                if ($nextDiv.length > 0) {
                    $nextDiv.addClass("callout");
                    if ($incompleteDivs.length < 2) {
                        $skipLinkDivs.removeClass("d-grid"); //.hide();
                    }
                    $nextDiv.addClass("d-grid"); //.show();
                } else {
                    $incompleteDivs.removeClass("skipped");
                    displayNextGuidedStep();
                }
            } else {
                $("#guideComplete").addClass("d-grid"); //.show();
            }
        }

        $skipLinkDivs.find("a").on("click", function (e) {
            var $thisDiv = $(this).closest(".card-block.guide");
            $thisDiv.removeClass("callout");
            $thisDiv.addClass("skipped");
            displayNextGuidedStep();
            e.preventDefault();
        });

        $tabs.find("a").on("click", function (e) {
            if ($(this).is('[aria-expanded*="false"]')) {
                $tabs.find("li").removeClass("active").find("a").attr("aria-expanded", "false");
                $(this).attr("aria-expanded", "true").closest("li").addClass("active");
            }
            if ($(this).is('[data-bs-target*="allGuides"]')) {
                $guides.removeClass("skipped");
                $guides.addClass("d-grid"); //.show();
                $skipLinkDivs.removeClass("d-grid"); //.hide();
                $("#guideComplete").removeClass("d-grid"); //.hide();
            } else {
                $skipLinkDivs.addClass("d-grid"); //.show();
                displayNextGuidedStep();
            }
            e.preventDefault();
        });

        function persistStepState(id, state) {
            var model = {};
            model.GuidedStepId = id;
            model.IsComplete = state;

            $.ajax({
                url: "/api/saveguidedsteps/updateuserstep",
                type: "POST",
                dataType: "json",
                context: this,
                data: model,
                headers: {
                    RequestVerificationToken: utils.getRequestVerificationToken()
                },
                success: function (data) {
                    if (data !== "OK") {
                        console.log($("#guideSaveError").text());
                    }
                },
                error: function () {
                    console.error($("#guideSaveError").text());
                }
            });
        }

        $checkbox.on("click", function () {
            var id = $(this).data("id");
            var stepTitle = $(this).data("step");
            if ($(this).is('[aria-pressed*="true"]')) {
                persistStepState(id, false);
                $(this).attr("aria-pressed", "false");
                $(this).closest(".card-block.guide").removeClass("complete");
                $("#guideComplete").removeClass("d-grid"); //.hide();
            } else if ($(this).is('[aria-pressed*="false"]')) {
                persistStepState(id, true);
                $(this).attr("aria-pressed", "true");
                $(this).closest(".card-block.guide").addClass("complete");

                // update the guided view
                if ($('*[data-bs-target="calloutGuides"]').attr("aria-expanded") === "true") {
                    var $thisDiv = $(this).closest(".card-block.guide");
                    $thisDiv.removeClass("callout");

                    displayNextGuidedStep();
                }
                var event = {
                    event: "preparedComplete",
                    readinessStep: stepTitle
                };
                dataLayerService.pushEventToGtmDataLayer(event);
            }
            updateProgressBar();
        });

        // initialize control
        displayNextGuidedStep();
        updateProgressBar();
    }

    function initAlreadyRegisteredCheckbox() {
        var $alreadyRegisteredCheckbox = $("input#checkboxCaregiver");
        var $alreadyRegisteredLogin = $("#alreadyRegisteredLogin");
        var $notRegisteredLogin = $("#notRegisteredLogin");
        if ($alreadyRegisteredCheckbox.length > 0) {
            function checkCheckbox() {
                console.log("check");
                if ($alreadyRegisteredCheckbox.prop("checked")) {
                    $alreadyRegisteredLogin.show();
                    $notRegisteredLogin.hide();
                } else {
                    $alreadyRegisteredLogin.hide();
                    $notRegisteredLogin.show();
                }
            }

            $alreadyRegisteredCheckbox.on("change", checkCheckbox);
            checkCheckbox();
        }
    }

    function initEmailAsUsername() {
        var $emailAsUsername = $("input#emailAsUsername");
        var $email = $("input#email");
        var $confirmEmail = $("input#confirmEmail");
        var $username = $("input#username");
        var $confirmUsername = $("input#confirmUsername");
        if ($emailAsUsername.length > 0) {
            function checkCheckboxEmailAsUsername() {
                console.log("checkCheckbox EmailAsUsername");
                if ($emailAsUsername.prop("checked")) {
                    $username.val($email.val());
                    $username.prop("readonly", true);
                    $confirmUsername.val($confirmEmail.val());
                    $confirmUsername.prop("readonly", true);
                } else {
                    $username.val("");
                    $confirmUsername.val("");
                    $username.prop("readonly", false);
                    $confirmUsername.prop("readonly", false);
                }
            }

            $emailAsUsername.on("change", checkCheckboxEmailAsUsername);
            checkCheckboxEmailAsUsername();

            function enableCheckbox() {
                if ($email.val() == $confirmEmail.val() && $email.val() != "" && $confirmEmail.val() != "") {
                    $emailAsUsername.prop("disabled", false);
                } else {
                    $emailAsUsername.prop("disabled", true);
                }
            }

            $confirmEmail.on("change", enableCheckbox);
            enableCheckbox();
        }
    }

    function initFormattedDateInputField() {
        var date = $("input.formatDate");
        if (date.length > 0) {
            function checkValue(str, max) {
                if (str.charAt(0) !== "0" || str === "00") {
                    var num = parseInt(str);
                    if (isNaN(num) || num <= 0 || num > max) num = 1;
                    str = num > parseInt(max.toString().charAt(0)) && num.toString().length === 1 ? "0" + num : num.toString();
                }
                return str;
            }

            date.on("input", function (e) {
                this.type = "text";
                var input = this.value;
                if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
                var values = input.split("/").map(function (v) {
                    return v.replace(/\D/g, "");
                });
                if (values[0]) values[0] = checkValue(values[0], 12);
                if (values[1]) values[1] = checkValue(values[1], 31);
                var output = values.map(function (v, i) {
                    return v.length === 2 && i < 2 ? v + "/" : v;
                });
                this.value = output.join("").substr(0, 14);
            });

            date.on("blur", function (e) {
                this.type = "text";
                var input = this.value;
                var values = input.split("/").map(function (v, i) {
                    return v.replace(/\D/g, "");
                });
                var output = "";

                if (values.length === 3) {
                    var year = values[2].length !== 4 ? parseInt(values[2]) + 2000 : parseInt(values[2]);
                    var month = parseInt(values[0]) - 1;
                    var day = parseInt(values[1]);
                    var d = new Date(year, month, day);
                    if (!isNaN(d)) {
                        var dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
                        output = dates
                            .map(function (v) {
                                v = v.toString();
                                return v.length === 1 ? "0" + v : v;
                            })
                            .join("/");
                    }
                }
                this.value = output;
            });
        }
    }

    function detectIEBrowsers() {
        var target = document.querySelector("body");

        // ie10
        var isIE10 = false;
        /*@cc_on
            if (/^10/.test(@_jscript_version)) {
                isIE10 = true;
            }
        @*/
        if (isIE10) {
            target.className += " isIE10";
        }

        // ie11
        var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        if (isIE11) {
            target.className += " isIE11";
        }

        // Edge using User-Agent sniffing
        var edge = window.navigator.userAgent.indexOf("Edge") > -1;
        if (edge) {
            target.className += " isEdge";
        }
    }

    function initHCRMedsFocusMgmt() {
        $(".health-care-record-container .right-rail-container .hcr-meds-container > header .btn").on("click", function (ev) {
            var $target = $($(ev.target).attr("data-bs-target"));
            setTimeout(function () {
                $target.find("input").eq(0).focus();
                // $("#formularyDrugName").focus();
            }, 500);
        });
        $("#addRx header > .btn, #addNonRx header > .btn").on("click", function (ev) {
            setTimeout(function () {
                $(ev.target).closest(".hcr-meds-container").find("> header .btn").focus();
            }, 500);
        });
    }

    function initExpandCollapse() {
        $(".collapse-toggle").on("click", function (e) {
            var target = $(this).data("bs-target");
            if ($(this).is(".active")) {
                $(target).collapse("hide");
                $(this).removeClass("active").attr("aria-expanded", "false");
            } else {
                $(target).collapse("show");
                $(this).addClass("active").attr("aria-expanded", "true");
            }
            e.preventDefault();
        });
    }

    function initTabCollapse() {
        var $tabContainer = $(".collapsible-tabs-container");
        if ($tabContainer.length > 0) {
            $tabContainer.each(function () {
                $(this).find(".nav").tabCollapse({
                    tabsClass: "hidden-sm hidden-xs",
                    accordionClass: "visible-sm visible-xs"
                });
            });
        }

        var tabEls = document.querySelectorAll('li[role="presentation"] [data-bs-toggle="tab"]');
        tabEls.forEach(function (el) {
            $(el).on("show.bs.tab", function (event) {
                $(event.target).closest(".nav-tabs").find("li").removeClass("active");
                $(event.target).closest("li").addClass("active");
            });
        });
    }

    function initPageZoom() {
        var currZoom = $("body").css("zoom");
        if (currZoom === "normal") currZoom = 1; // For IE

        $(".btn-zoom").on("click", function () {
            if ($(this).is(".reset")) {
                $("body").removeClass("zoom");
                $(this).removeClass("reset");
            } else {
                $("body").addClass("zoom");
                $(this).addClass("reset");
            }
        });
    }

    function initStickyContact() {
        var controller = new ScrollMagic.Controller();
        var $stickyContact = $("#stickyContact");
        // use a function to automatically adjust the duration to the window height.
        var durationValueCache;

        function getDuration() {
            return durationValueCache;
        }

        function updateDuration() {
            durationValueCache = $(".detail-content-wrapper").height() - $stickyContact.height();
        }

        $(window).on("resize", updateDuration); // update the duration when the window size changes
        $(window).triggerHandler("resize"); // set to initial value

        $(window).on("load", updateDuration); // update the duration when the window loads
        $(".detail-wrapper .show-more-link a").on("click", updateDuration); // update the duration when the content is expanded

        if ($("#stickyContact").length > 0) {
            // sticky contact
            new ScrollMagic.Scene({
                triggerElement: "#stickyContact",
                triggerHook: "onLeave",
                offset: -20,
                reverse: true
            })
                .setPin("#stickyContact")
                .duration(getDuration)
                .addTo(controller);
        }
    }

    function initSticky() {
        const controller = new ScrollMagic.Controller();

        const stickyContent = document.querySelector(".stickyContent");
        if (stickyContent === null) {
            return;
        }
        let sibling = stickyContent.dataset.stickyReferenceClass.startsWith(".") ? document.querySelector(stickyContent.dataset.stickyReferenceClass) : document.querySelector("." + stickyContent.dataset.stickyReferenceClass);

        if (!sibling) {
            console.error("missing sticky-reference-class data attribute on .stickyContent element");
            return;
        }

        // use a function to automatically adjust the duration to the window height.
        let durationValueCache;

        function getDuration() {
            return durationValueCache || sibling.offsetHeight - stickyContent.offsetHeight;
        }

        function updateDuration() {
            durationValueCache = sibling.offsetHeight - stickyContent.offsetHeight;
        }

        // sticky content
        const scene = new ScrollMagic.Scene({
            triggerElement: stickyContent,
            triggerHook: 0,
            duration: getDuration
        }).addTo(controller);

        if (window.matchMedia("(min-width: 768px)").matches) {
            scene.setPin(stickyContent, { pushFollowers: false });
        }

        window.addEventListener("resize", () => {
            if (window.matchMedia("(min-width: 768px)").matches) {
                scene.setPin(stickyContent, { pushFollowers: false });
            } else {
                scene.removePin(stickyContent, true);
            }
        });

        $(window).on("load", updateDuration); // update the duration when the window loads
    }

    function initNotificationReply() {
        var $notificationActions = $(".notification-actions-container");
        if ($notificationActions.length > 0) {
            $notificationActions.find(".reply-btn").on("click", function () {
                if ($notificationActions.find(".send-message").is(":hidden")) {
                    $notificationActions.find(".send-message").show();
                    $notificationActions.find(".reply-message").hide();
                }
            });
            $notificationActions.find(".cancel-reply-btn").on("click", function () {
                if ($notificationActions.find(".reply-message").is(":hidden")) {
                    $notificationActions.find(".send-message").hide();
                    $notificationActions.find(".reply-message").show();
                }
            });
        }
    }

    function initClearFileUpload() {
        var $fileUploader = $(".file-uploader");
        if ($fileUploader.length > 0) {
            // Setup the clear functionality
            $fileUploader.find('input[type="file"]').on("change", function (ev) {
                let fileuploadId = $(ev.target).attr("id");
                if ($(this).val()) {
                    $(this).closest(".file-uploader").addClass("attached");
                    if (window.secureMessagingVM) {
                        // add filename to attachments array in knockout
                        var filename = $(ev.target).val().split("\\").pop();
                        fileuploadId = $(ev.target).attr("id");
                        switch (fileuploadId) {
                            case "Attachment1":
                                window.secureMessagingVM.firstAttachment({ id: "uno", title: filename });
                                break;
                            case "Attachment2":
                                window.secureMessagingVM.secondAttachment({ id: "dos", title: filename });
                                break;
                            case "Attachment3":
                                window.secureMessagingVM.thirdAttachment({ id: "tres", title: filename });
                                break;
                            default:
                                break;
                        }
                    }
                } else {
                    $(this).closest(".file-uploader").removeClass("attached");

                    switch (fileuploadId) {
                        case "Attachment1":
                            window.secureMessagingVM.firstAttachment({});
                            break;
                        case "Attachment2":
                            window.secureMessagingVM.secondAttachment({});
                            break;
                        case "Attachment3":
                            window.secureMessagingVM.thirdAttachment({});
                            break;
                        default:
                            break;
                    }
                }
            });
            $fileUploader.find(".clear-btn").on("click", function (ev) {
                ev.preventDefault();

                var $fileInput = $(this).parent().find('input[type="file"]');
                // first, remove filename to attachments array in knockout before we clear the input
                switch ($fileInput.attr("id")) {
                    case "Attachment1":
                        window.secureMessagingVM.firstAttachment({});
                        break;
                    case "Attachment2":
                        window.secureMessagingVM.secondAttachment({});
                        break;
                    case "Attachment3":
                        window.secureMessagingVM.thirdAttachment({});
                        break;
                    default:
                        break;
                }
                $fileInput.val("");
                $(this).closest(".file-uploader").removeClass("attached");
            });
        }
    }

    function fitbitColorSelect() {
        $(".product-img").hide();
        $(".fitbit-color-select .form-checkbox").on("click", function () {
            $(".product-img").hide();
            $(".product-picker").attr("aria-checked", "false");
            $(this).find("input").attr("aria-checked", "true");
            $("." + $(this).find("input").attr("data-prodimg")).show();
            $(".product-name").text($(this).find("span").text());
        });
        $(".product-img").eq(0).show();
        $(".product-name").text($(".fitbit-color-select .form-checkbox").eq(0).find("span").text());
    }

    function initShareWrapInternal() {
        $(".social")
            .find("a")
            .each(function () {
                if ($(this).find("span").length === 0) {
                    $(this).wrapInner('<span class="sr-only"></span>');
                }
                $(this).addClass("active");
            });
    }

    function setupCollapsibleFooterLinksForMobile() {
        var $iconPlus = $("<span/>", { class: "icon icon-close" });

        $("footer.footer nav").each(function () {
            if (!$(this).hasClass("mobilized")) {
                var dynId = "_" + Math.random().toString(36).substr(2, 9);
                $(this).addClass("mobilized");
                $(this).find("ul").addClass("collapse").attr("id", dynId).collapse("hide");

                $(this)
                    .find("h2")
                    .addClass("collapsed")
                    .attr("data-bs-target", "#" + dynId)
                    .attr("data-bs-toggle", "collapse")
                    .attr("aria-controls", dynId)
                    .append($iconPlus.clone());

                $(this)
                    .find("h2")
                    .on("click", function (ev) {
                        if (ev.target === "h2") {
                            return false;
                        }
                    });

                $("#" + dynId)
                    .on("show.bs.collapse", function () {
                        $("[aria-controls=" + dynId + "]").removeClass("collapsed");
                    })
                    .on("hide.bs.collapse", function () {
                        $("[aria-controls=" + dynId + "]").addClass("collapsed");
                    });
            }
        });
    }

    function destroyCollapsible() {
        $("footer.footer nav").each(function () {
            $(this).removeClass("mobilized");
            $(this).find("h2").removeClass("collapsed").removeAttr("data-bs-target").removeAttr("data-bs-toggle").removeAttr("aria-controls").removeAttr("aria-expanded");
            $(this).find(".icon-close").remove();
            $(this).find("ul").collapse("show");
        });
    }

    function makeOrBreakCollapsibleFooterLinksForMobile(ev) {
        if (window.innerWidth > 660) {
            destroyCollapsible();
        } else {
            setupCollapsibleFooterLinksForMobile();
        }
    }

    function runAndSetListenerForMobileFooterLinksController() {
        setTimeout(function () {
            makeOrBreakCollapsibleFooterLinksForMobile(null);
        }, 500);

        $(window).on("resize orientationchange", utils.debounce(makeOrBreakCollapsibleFooterLinksForMobile, 250));
    }

    function initStateSelectorFocusTrap() {
        var makeKeydownListener = function (element) {
            var focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
            var firstFocusableEl = focusableEls[0];
            var lastFocusableEl = focusableEls[focusableEls.length - 1];
            var KEYCODE_TAB = 9;

            return function (e) {
                var isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

                if (!isTabPressed) {
                    return;
                }

                if (e.shiftKey) {
                    /* shift + tab */
                    if (document.activeElement === firstFocusableEl) {
                        lastFocusableEl.focus();
                        e.preventDefault();
                    }
                } /* tab */ else {
                    if (document.activeElement === lastFocusableEl) {
                        firstFocusableEl.focus();
                        e.preventDefault();
                    }
                }
            };
        };
        var _listener;

        function trapFocus(element) {
            _listener = makeKeydownListener(element);
            element.addEventListener("keydown", _listener);
        }

        if ($(".modal.list-states").hasClass("show")) {
            setTimeout(function () {
                $(".modal.list-states.show .state-card").eq(0).focus();
                trapFocus($(".modal.list-states.show")[0]);
            }, 500);
        }
    }

    // get inner height of viewport and set custom property to root
    // used to maximize viewport on mobile scrolling
    function initMobileHeightCalc() {
        if (!window.matchMedia("(min-width: 992px)").matches) {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
            // resize event with debounce for performance.
            window.addEventListener(
                "resize",
                utils.debounce(function () {
                    initMobileHeightCalc();
                }, 500)
            );
        }
    }

    function initFacilityTypeSelector() {
        // Document-level click event listener
        document.addEventListener("click", function (event) {
            var collapseElement = document.getElementById("facilityTypeSelector");
            if (!collapseElement) {
                return;
            }

            var isClickInsideCollapse = collapseElement.contains(event.target);

            if (!isClickInsideCollapse && collapseElement.classList.contains("show")) {
                var bootstrapCollapse = new bootstrap.Collapse(collapseElement);
                bootstrapCollapse.hide();
            }
        });
    }

    function newerDebounce(func, timeout = 300) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    }

    function initPromoTilesTitleHeight() {
        const promoTiles = document.querySelectorAll(".promo-tiles");
        promoTiles.forEach(promoTilesGroup => {
            const tiles = promoTilesGroup.querySelectorAll(".promo-tile");
            let maxTitleHeight = 0;
            tiles.forEach(tile => {
                const title = tile.querySelector(".promo-tile-title");
                // remove old height
                title.style.height = "";
                // console.log(title.innerHTML + " height is " + title.offsetHeight);
                if (title.offsetHeight > maxTitleHeight) {
                    maxTitleHeight = title.offsetHeight;
                }
            });
            // console.log("max height is " + maxTitleHeight);
            tiles.forEach(tile => {
                const title = tile.querySelector(".promo-tile-title");
                title.style.height = maxTitleHeight + "px";
            });
        });
    }

    const debouncedInitPromoTilesTitleHeight = newerDebounce(() => initPromoTilesTitleHeight());

    function addClassToWrapperIfBreadcrumbHidden() {
        if (!$(".breadcrumbs").is(":visible")) {
            $(".pre-header").addClass("dg-1");
        }
    }

    function setMainElementWidthAsCSSVariable() {
        // Select the .page element
        const pageElement = document.querySelector('.page');

        // Check if .page exists and has a direct child with the ID #main
        if (pageElement && pageElement.querySelector(':scope > #main')) {
            // Get the #main element
            const mainElement = pageElement.querySelector(':scope > #main');

            // Get the width of the #main element
            const mainWidth = mainElement.offsetWidth;

            // Set a CSS variable on the #main element
            mainElement.style.setProperty('--main-width', `${mainWidth}px`);

            console.log(`CSS variable '--main-width' set to ${mainWidth}px`);
        } else {
            console.log('The conditions were not met.');
        }
    }

    return function () {
        // bind resize handler to trigger screenbreakpoint
        initScreenBreakpointEvent();

        // add helpful classes to the page
        addPageClasses();

        // init open close for Login
        initLoginOpenClose();

        // init open close for Card hint
        initCardOpenClose();

        // init open close for Card Plan
        initCardPlanOpenClose();

        // init open close for Card Plan
        initDisclaimerOpenClose();

        // init open close for Card Plan
        initFilterOpenClose();

        // init open close for Actions
        initActionsOpenClose();

        // init open close for Card Plan
        initFormInfoOpenClose();

        // init accordion
        initAccordion();

        // init bootstrapSelect
        initBootstrapSelect();

        // init placeholder
        initPlaceholder();

        // init slick gallery
        initGallery();

        // init bootstrap alert plugin
        initBootstrapAlert();

        // init extend open close plugin
        initExtendOpenClose();

        // init Gallery Same Height plugin
        initGallerySameHeight();

        // init Slick Gallery plugin
        initPolicySearchGallery();

        // init Slick Gallery Same Height
        initPolicyGallerySameHeight();

        //init Open Close for Plan Materials
        initPlanMaterilasOpenClose();

        //init Open Close for Card Example
        initCardExampleOpenClose();

        initModalFunctions();
        initSmoothScroll();
        initTableSort();
        initPortalTabNav();
        initProfileCollapse();
        initOneNavOpenAtATime();
        initFilterBoxFilters();
        initPlanFinderQuestions();
        initPlanFinderHelp();
        initPlanFinderCompareBlocks();
        initStickyCompare();
        tableShowMore();
        passwordValidation();
        skipNav();
        initPopover();
        initConAcctAddAccountCollapsible();
        lookupToolsFilterOverlay();
        lookupToolsOverlay();
        initToolTip();
        initMemberPortalGuide();

        // favorite button functionality is now in modules/portal/favorites
        //initFavoriteButton();

        initAlreadyRegisteredCheckbox();
        initFormattedDateInputField();

        initEmailAsUsername();

        detectIEBrowsers();

        initHCRMedsFocusMgmt();

        // initExpandCollapse();
        initPageZoom();
        initTabCollapse();
        // initStickyContact();
        initSticky();

        initNotificationReply();

        initClearFileUpload();
        fitbitColorSelect();
        initShareWrapInternal();
        runAndSetListenerForMobileFooterLinksController();
        initStateSelectorFocusTrap();
        initMobileHeightCalc();
        // memberPortalFileUploadListener();

        $(".question-hide").each(function () {
            $(this).closest("li").addClass("hide");
        });

        if ($("#address-context-lead-form-request").length > 0) {
            dataLayer.push({
                event: "address-context-lead-form-submitSuccess",
                formRequest: $("#address-context-lead-form-request").html()
            });
        }

        initFacilityTypeSelector();

        initPromoTilesTitleHeight();
        $(window).on("resize", debouncedInitPromoTilesTitleHeight);

        addClassToWrapperIfBreadcrumbHidden();

        setMainElementWidthAsCSSVariable();
        $(window).on("resize", setMainElementWidthAsCSSVariable);
    };
});
